// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Styles for 24 grid layout
 *
 */


/*
    v=[]; for (let i=1; i <= 24; i++) v.push(((100/24) * i).toFixed(3)); console.log(v)
    v.forEach((p,i) => console.log(\`.gs-24 > .grid-stack-item[gs-x="\${i+1}"] {\\n    left: \${p}%;\\n}\`))
    v.forEach((p,i) => console.log(\`.gs-24 > .grid-stack-item[gs-w="\${i+1}"] {\\n    width: \${p}%;\\n}\`))
*/

.gs-24 > .grid-stack-item {
    width: 4.167%;
} 
.gs-24 > .grid-stack-item[gs-x="1"] {
    left: 4.167%;
}
.gs-24 > .grid-stack-item[gs-x="2"] {
    left: 8.333%;
}
.gs-24 > .grid-stack-item[gs-x="3"] {
    left: 12.500%;
}
.gs-24 > .grid-stack-item[gs-x="4"] {
    left: 16.667%;
}
.gs-24 > .grid-stack-item[gs-x="5"] {
    left: 20.833%;
}
.gs-24 > .grid-stack-item[gs-x="6"] {
    left: 25.000%;
}
.gs-24 > .grid-stack-item[gs-x="7"] {
    left: 29.167%;
}
.gs-24 > .grid-stack-item[gs-x="8"] {
    left: 33.333%;
}
.gs-24 > .grid-stack-item[gs-x="9"] {
    left: 37.500%;
}
.gs-24 > .grid-stack-item[gs-x="10"] {
    left: 41.667%;
}
.gs-24 > .grid-stack-item[gs-x="11"] {
    left: 45.833%;
}
.gs-24 > .grid-stack-item[gs-x="12"] {
    left: 50.000%;
}
.gs-24 > .grid-stack-item[gs-x="13"] {
    left: 54.167%;
}
.gs-24 > .grid-stack-item[gs-x="14"] {
    left: 58.333%;
}
.gs-24 > .grid-stack-item[gs-x="15"] {
    left: 62.500%;
}
.gs-24 > .grid-stack-item[gs-x="16"] {
    left: 66.667%;
}
.gs-24 > .grid-stack-item[gs-x="17"] {
    left: 70.833%;
}
.gs-24 > .grid-stack-item[gs-x="18"] {
    left: 75.000%;
}
.gs-24 > .grid-stack-item[gs-x="19"] {
    left: 79.167%;
}
.gs-24 > .grid-stack-item[gs-x="20"] {
    left: 83.333%;
}
.gs-24 > .grid-stack-item[gs-x="21"] {
    left: 87.500%;
}
.gs-24 > .grid-stack-item[gs-x="22"] {
    left: 91.667%;
}
.gs-24 > .grid-stack-item[gs-x="23"] {
    left: 95.833%;
}
.gs-24 > .grid-stack-item[gs-x="24"] {
    left: 100.000%;
}


.gs-24 > .grid-stack-item[gs-w="1"] {
    width: 4.167%;
}
.gs-24 > .grid-stack-item[gs-w="2"] {
    width: 8.333%;
}
.gs-24 > .grid-stack-item[gs-w="3"] {
    width: 12.500%;
}
.gs-24 > .grid-stack-item[gs-w="4"] {
    width: 16.667%;
}
.gs-24 > .grid-stack-item[gs-w="5"] {
    width: 20.833%;
}
.gs-24 > .grid-stack-item[gs-w="6"] {
    width: 25.000%;
}
.gs-24 > .grid-stack-item[gs-w="7"] {
    width: 29.167%;
}
.gs-24 > .grid-stack-item[gs-w="8"] {
    width: 33.333%;
}
.gs-24 > .grid-stack-item[gs-w="9"] {
    width: 37.500%;
}
.gs-24 > .grid-stack-item[gs-w="10"] {
    width: 41.667%;
}
.gs-24 > .grid-stack-item[gs-w="11"] {
    width: 45.833%;
}
.gs-24 > .grid-stack-item[gs-w="12"] {
    width: 50.000%;
}
.gs-24 > .grid-stack-item[gs-w="13"] {
    width: 54.167%;
}
.gs-24 > .grid-stack-item[gs-w="14"] {
    width: 58.333%;
}
.gs-24 > .grid-stack-item[gs-w="15"] {
    width: 62.500%;
}
.gs-24 > .grid-stack-item[gs-w="16"] {
    width: 66.667%;
}
.gs-24 > .grid-stack-item[gs-w="17"] {
    width: 70.833%;
}
.gs-24 > .grid-stack-item[gs-w="18"] {
    width: 75.000%;
}
.gs-24 > .grid-stack-item[gs-w="19"] {
    width: 79.167%;
}
.gs-24 > .grid-stack-item[gs-w="20"] {
    width: 83.333%;
}
.gs-24 > .grid-stack-item[gs-w="21"] {
    width: 87.500%;
}
.gs-24 > .grid-stack-item[gs-w="22"] {
    width: 91.667%;
}
.gs-24 > .grid-stack-item[gs-w="23"] {
    width: 95.833%;
}
.gs-24 > .grid-stack-item[gs-w="24"] {
    width: 100.000%;
}



.gs-1 > .grid-stack-item {
    width: 100%;
} 


.gs-2 > .grid-stack-item {
    width: 50%;
} 
.gs-2 > .grid-stack-item[gs-x="1"] {
    left: 50%;
}
.gs-2 > .grid-stack-item[gs-w="1"] {
    width: 50%;
}
.gs-2 > .grid-stack-item[gs-w="2"] {
    width: 100%;
}
`, "",{"version":3,"sources":["webpack://./app_react/src/schemaengine/client/SchemaLayoutGridStack.css"],"names":[],"mappings":"AAAA;;;EAGE;;;AAGF;;;;CAIC;;AAED;IACI,aAAa;AACjB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,cAAc;AAClB;;;AAGA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,eAAe;AACnB;;;;AAIA;IACI,WAAW;AACf;;;AAGA;IACI,UAAU;AACd;AACA;IACI,SAAS;AACb;AACA;IACI,UAAU;AACd;AACA;IACI,WAAW;AACf","sourcesContent":["/**\n * Styles for 24 grid layout\n *\n */\n\n\n/*\n    v=[]; for (let i=1; i <= 24; i++) v.push(((100/24) * i).toFixed(3)); console.log(v)\n    v.forEach((p,i) => console.log(`.gs-24 > .grid-stack-item[gs-x=\"${i+1}\"] {\\n    left: ${p}%;\\n}`))\n    v.forEach((p,i) => console.log(`.gs-24 > .grid-stack-item[gs-w=\"${i+1}\"] {\\n    width: ${p}%;\\n}`))\n*/\n\n.gs-24 > .grid-stack-item {\n    width: 4.167%;\n} \n.gs-24 > .grid-stack-item[gs-x=\"1\"] {\n    left: 4.167%;\n}\n.gs-24 > .grid-stack-item[gs-x=\"2\"] {\n    left: 8.333%;\n}\n.gs-24 > .grid-stack-item[gs-x=\"3\"] {\n    left: 12.500%;\n}\n.gs-24 > .grid-stack-item[gs-x=\"4\"] {\n    left: 16.667%;\n}\n.gs-24 > .grid-stack-item[gs-x=\"5\"] {\n    left: 20.833%;\n}\n.gs-24 > .grid-stack-item[gs-x=\"6\"] {\n    left: 25.000%;\n}\n.gs-24 > .grid-stack-item[gs-x=\"7\"] {\n    left: 29.167%;\n}\n.gs-24 > .grid-stack-item[gs-x=\"8\"] {\n    left: 33.333%;\n}\n.gs-24 > .grid-stack-item[gs-x=\"9\"] {\n    left: 37.500%;\n}\n.gs-24 > .grid-stack-item[gs-x=\"10\"] {\n    left: 41.667%;\n}\n.gs-24 > .grid-stack-item[gs-x=\"11\"] {\n    left: 45.833%;\n}\n.gs-24 > .grid-stack-item[gs-x=\"12\"] {\n    left: 50.000%;\n}\n.gs-24 > .grid-stack-item[gs-x=\"13\"] {\n    left: 54.167%;\n}\n.gs-24 > .grid-stack-item[gs-x=\"14\"] {\n    left: 58.333%;\n}\n.gs-24 > .grid-stack-item[gs-x=\"15\"] {\n    left: 62.500%;\n}\n.gs-24 > .grid-stack-item[gs-x=\"16\"] {\n    left: 66.667%;\n}\n.gs-24 > .grid-stack-item[gs-x=\"17\"] {\n    left: 70.833%;\n}\n.gs-24 > .grid-stack-item[gs-x=\"18\"] {\n    left: 75.000%;\n}\n.gs-24 > .grid-stack-item[gs-x=\"19\"] {\n    left: 79.167%;\n}\n.gs-24 > .grid-stack-item[gs-x=\"20\"] {\n    left: 83.333%;\n}\n.gs-24 > .grid-stack-item[gs-x=\"21\"] {\n    left: 87.500%;\n}\n.gs-24 > .grid-stack-item[gs-x=\"22\"] {\n    left: 91.667%;\n}\n.gs-24 > .grid-stack-item[gs-x=\"23\"] {\n    left: 95.833%;\n}\n.gs-24 > .grid-stack-item[gs-x=\"24\"] {\n    left: 100.000%;\n}\n\n\n.gs-24 > .grid-stack-item[gs-w=\"1\"] {\n    width: 4.167%;\n}\n.gs-24 > .grid-stack-item[gs-w=\"2\"] {\n    width: 8.333%;\n}\n.gs-24 > .grid-stack-item[gs-w=\"3\"] {\n    width: 12.500%;\n}\n.gs-24 > .grid-stack-item[gs-w=\"4\"] {\n    width: 16.667%;\n}\n.gs-24 > .grid-stack-item[gs-w=\"5\"] {\n    width: 20.833%;\n}\n.gs-24 > .grid-stack-item[gs-w=\"6\"] {\n    width: 25.000%;\n}\n.gs-24 > .grid-stack-item[gs-w=\"7\"] {\n    width: 29.167%;\n}\n.gs-24 > .grid-stack-item[gs-w=\"8\"] {\n    width: 33.333%;\n}\n.gs-24 > .grid-stack-item[gs-w=\"9\"] {\n    width: 37.500%;\n}\n.gs-24 > .grid-stack-item[gs-w=\"10\"] {\n    width: 41.667%;\n}\n.gs-24 > .grid-stack-item[gs-w=\"11\"] {\n    width: 45.833%;\n}\n.gs-24 > .grid-stack-item[gs-w=\"12\"] {\n    width: 50.000%;\n}\n.gs-24 > .grid-stack-item[gs-w=\"13\"] {\n    width: 54.167%;\n}\n.gs-24 > .grid-stack-item[gs-w=\"14\"] {\n    width: 58.333%;\n}\n.gs-24 > .grid-stack-item[gs-w=\"15\"] {\n    width: 62.500%;\n}\n.gs-24 > .grid-stack-item[gs-w=\"16\"] {\n    width: 66.667%;\n}\n.gs-24 > .grid-stack-item[gs-w=\"17\"] {\n    width: 70.833%;\n}\n.gs-24 > .grid-stack-item[gs-w=\"18\"] {\n    width: 75.000%;\n}\n.gs-24 > .grid-stack-item[gs-w=\"19\"] {\n    width: 79.167%;\n}\n.gs-24 > .grid-stack-item[gs-w=\"20\"] {\n    width: 83.333%;\n}\n.gs-24 > .grid-stack-item[gs-w=\"21\"] {\n    width: 87.500%;\n}\n.gs-24 > .grid-stack-item[gs-w=\"22\"] {\n    width: 91.667%;\n}\n.gs-24 > .grid-stack-item[gs-w=\"23\"] {\n    width: 95.833%;\n}\n.gs-24 > .grid-stack-item[gs-w=\"24\"] {\n    width: 100.000%;\n}\n\n\n\n.gs-1 > .grid-stack-item {\n    width: 100%;\n} \n\n\n.gs-2 > .grid-stack-item {\n    width: 50%;\n} \n.gs-2 > .grid-stack-item[gs-x=\"1\"] {\n    left: 50%;\n}\n.gs-2 > .grid-stack-item[gs-w=\"1\"] {\n    width: 50%;\n}\n.gs-2 > .grid-stack-item[gs-w=\"2\"] {\n    width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
